export default "__VITE_ASSET__c0cf8937__"